import React from 'react';

const Repeat = (props: any) => {
    let items = [];
    for (let i = 0; i < props.numTimes; i++) {
        items.push(props.children(i));
    }
    return <React.Fragment>{items}</React.Fragment>;
}
export default Repeat;